import { ScrollToTop } from 'react-simple-scroll-up';
import { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';

export default function Technology() {
  const { content } = useContext(LanguageContext);

  return (
    <div
      className="min-h-screen font-bold flex flex-col font-dosis items-center justify-center"
      style={{ backgroundColor: '#EEEEEE' }}
      id="technology"
    >
      <ScrollToTop className="mt-20">
        <span>UP</span>
      </ScrollToTop>

      <h1 className="text-3xl md:text-3xl font-bold mb-10 text-center md:text-left">
        {content.stack.title}
      </h1>

      <div className="flex flex-wrap justify-center md:justify-start mt-10">
        {content.stack.tech.map((tech, index) => (
          <span
            key={`element-${index}`}
            className={`
              ${index % 2 === 0 ? 'animate-float' : 'animate-refloat'}
              w-40 h-40 m-2 bg-white shadow-2xl items-center flex p-6 rounded-full
            `}
          >
            <img
              src={tech.img}
              alt={tech.alt}
              loading="lazy"
              className="w-full h-full object-contain"
            />
          </span>
        ))}
      </div>

      <p className="md:text-2xl text-xl md:max-w-2xl text-center mt-10 mb-10">
        {content.stack.desc}
      </p>
    </div>
  );
}
